export default __webpack_public_path__ + "static/image-18-3779861e4b8a40033775adfc6d420beb.jpg";